import { WprBaseObject } from '../../WprBaseObject';
import { WprReflectUtil } from '../../util/WprReflectUtil';
import { WprControRefreshMap } from '../control/map/WprControRefreshMap';
import { WprControlInfo } from '../control/WprControlInfo';

/**
 * DI管理
 */
export abstract class WprBaseDIManage extends WprBaseObject {
	// static 変数  -------------------------------------------------------------
	public static	modelNameList: string[]		= new Array();		// @WprDI_ScopeModel設定用
	public static	gmodelNameList: string[]	= new Array();		// @WprDI_GlobalScopeModel設定用
	public static	listNameList: string[]		= new Array();		// @WprListData設定用
	// --------------------------------------------------------------------------

	// virtual メソッド  --------------------------------------------------------
	/**
	 * DI初回設定フラグ取得
	 * @returns DI初回設定フラグ
	 */
	public getIsSetOnece(): boolean {
		return false;
	}

	/**
	 * DI要コントロール情報マップ取得
	 * @returns DI要コントロール情報マップ
	 */
	public getDIControlMap(): WprControRefreshMap {
		return null;
	}

	/**
	 * DI元インスタンス取得
	 * @returns DI元インスタンス
	 */
	public getDIObjectFromInstance(): any {
		return null;
	}

	/**
	 * モデル設定通知
	 * @param name モデル名
	 * @param model モデル
	 */
	public onSetScopeModel(name: string, model: any): void {}

	/**
	 * モデル値チェック通知
	 * @param name モデル名
	 * @param model モデル
	 * @param isGlobal グローバルフラグ
	 * @param prop プロパティ名
	 */
	public onCheckModelValue(name: string, model: any, isGlobal: boolean, prop?: string): void {}
	// --------------------------------------------------------------------------

	// public メソッド  ---------------------------------------------------------
	/**
	 * インジェクション実行
	 */
	public execInjection(): void {
		this.injectionControl();
		this.injectionObject();
	}

	/**
	 * モデル値チェック処理
	 * @param name モデル名
	 * @param model モデル
	 * @param isGlobal グローバルフラグ
	 * @param prop プロパティ名
	 */
	public checkModelValue(name: string, model: any, isGlobal: boolean, prop?: string): void {
		this.onCheckModelValue(name, model, isGlobal, prop);
	}
	// --------------------------------------------------------------------------

	// private メソッド  --------------------------------------------------------
	/**
	 * コントロール情報インジェクト処理
	 */
	private injectionControl(): void {
		const map = this.getDIControlMap();
		if (map != null) {
			this.FW.model.getDecoNameList('Control', this).forEach((name) => {
				let dname = name;
				if (dname.startsWith('m_') === true)
					dname = dname.substring(2);
				let cinfo: WprControlInfo = null;
				if (map.has(dname) === true)
					cinfo = map.getControlInfo(dname);
				if (cinfo == null)
					cinfo = map.getControlInfo(dname.charAt(0).toLowerCase() + dname.slice(1));
				if (cinfo != null)
					WprReflectUtil.setProperty(this, name, cinfo);
				else
					this.addErrorLog(`コントロールのDI(WprDI_Control)に失敗しました。[${name}]`);
			});
		}
	}

	/**
	 * オブジェクトインジェクト処理
	 * @param obj インジェクト元オブジェクト
	 */
	protected injectionObject(instance?: object): void {
		if (!instance)
			instance = this.getDIObjectFromInstance();
		if (instance != null) {
			this.FW.model.getDecoNameList('Object', this).forEach((name) => {
				const obj = WprReflectUtil.getProperty(instance, name);
				if (obj != null)
					WprReflectUtil.setProperty(this, name, obj);
				else
					WprReflectUtil.setProperty(this, name, null);
					// this.addErrorLog(`オブジェクトのDI(WprDI_Object)に失敗しました。[${name}]`);
			});
		}
	}
	// --------------------------------------------------------------------------
}
